export const SOCIAL_STARTER_ROUTE_ID = 'psf-social-starter';
